export default __webpack_public_path__ + "static/inside-a453599fc1f8a618d3bb471d47742045.png";